import {useAppSelector} from '../../../store'

export const useSupportTickets = () => {
  return useAppSelector(({support}) => support.tickets)
}

export const useSupportTicket = () => {
  return useAppSelector(({support}) => support.ticket)
}

export const useSupportStatuses = () => {
  return useAppSelector(({support}) => support.statuses)
}

export const useSupportUnreadCount = () => {
  return useAppSelector(({support}) => support.unreadCount)
}

export const useSupportSteps = () => {
  return useAppSelector(({support}) => support.steps)
}

export const useCreatedSupportTicket = () => {
  return useAppSelector(({support}) => support.createdTicket)
}
